

/* @ngInject */ 
export default function($templateCache) {
	var templateString = $templateCache.get('templates/auth-nav-tmpl.html');
	return {
		bindToController: true,
		template: templateString,
		replace: true,
		restrict: 'E'
	};
}
